import classNames from "classnames";
import React from "react";

import { PolymorphicComponentProps } from "lib/@types/utils/polymorphic.types";

export type FormFeedbackComponentProps = {
    valid?: boolean;
    tooltip?: boolean;
};

export type FormFeedbackProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, FormFeedbackComponentProps, "div">;

const FormFeedback = <T extends React.ElementType = "div">({
    className,
    valid = undefined,
    tooltip,
    tag,
    ...attributes
}: FormFeedbackProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const validMode = tooltip ? "tooltip" : "feedback";

    const classes = classNames(
        className,
        valid ? `valid-${validMode}` : `invalid-${validMode}`,
    );

    return <Tag {...attributes} className={classes} />;
};

export { FormFeedback };
